export const passwordStrengthValidator =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~@$€£%^&*+=-`|:;,!.?"'()[\]]).{8,128}$/

export default passwordStrengthValidator
